module.exports = __webpack_public_path__ + "static/media/file-stl.2eae249c.svg";